import React from 'react';
import { __ } from '@wordpress/i18n';

// components
import Tooltip from '../Tooltip';
import PencilIcon from '../../icons/PencilIcon';
import CircleCheckIcon from '../../icons/CircleCheckIcon';
import ClockIcon from '../../icons/ClockIcon';

const IN_PROGRESS = 'in_progress';
const COMPLETED = 'completed';
const WAITING_FOR_REVIEW = 'waiting_for_review';

// The API does not return a project status yet. Until it does, anything we do
// not recognise falls back to "in progress" — the value the app hardcoded
// before — so a card never renders without a status icon.
const FALLBACK_STATUS = IN_PROGRESS;

// Tolerates the casing/naming variants a backend is likely to send.
const ALIASES = {
    [IN_PROGRESS]: IN_PROGRESS,
    inprogress: IN_PROGRESS,
    to_work: IN_PROGRESS,
    towork: IN_PROGRESS,
    [COMPLETED]: COMPLETED,
    complete: COMPLETED,
    done: COMPLETED,
    approved: COMPLETED,
    [WAITING_FOR_REVIEW]: WAITING_FOR_REVIEW,
    waitingforreview: WAITING_FOR_REVIEW,
    waiting_review: WAITING_FOR_REVIEW,
    on_review: WAITING_FOR_REVIEW,
    onreview: WAITING_FOR_REVIEW,
    in_review: WAITING_FOR_REVIEW,
    pending: WAITING_FOR_REVIEW
};

const CONFIG = {
    [IN_PROGRESS]: { icon: PencilIcon, label: __('In progress', 'soundbetween') },
    [COMPLETED]: { icon: CircleCheckIcon, label: __('Completed', 'soundbetween') },
    [WAITING_FOR_REVIEW]: { icon: ClockIcon, label: __('Waiting for review', 'soundbetween') }
};

export const normalizeProjectStatus = (status) => {
    if (!status) return FALLBACK_STATUS;

    const key = String(status).toLowerCase().replace(/[\s-]+/g, '_');

    return ALIASES[key] || ALIASES[key.replace(/_/g, '')] || FALLBACK_STATUS;
};

const ProjectStatusIcon = ({ status }) => {
    const resolved = normalizeProjectStatus(status);
    const { icon: Icon, label } = CONFIG[resolved];

    return (
        <Tooltip label={label}>
            <span
                className={`projectStatusIcon projectStatusIcon--${resolved}`}
                aria-label={label}
                role="img">
                <Icon/>
            </span>
        </Tooltip>
    )
}

export default ProjectStatusIcon;
